import { render } from "./AppImageCrop.vue?vue&type=template&id=2d71e6ce&scoped=true"
import script from "./AppImageCrop.vue?vue&type=script&lang=js"
export * from "./AppImageCrop.vue?vue&type=script&lang=js"

import "./AppImageCrop.vue?vue&type=style&index=0&id=2d71e6ce&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d71e6ce"]])

export default __exports__